<form class="token-input m-0" autocomplete="off">
  <input (paste)="inputDrop($event)" *ngFor="let input of arrData; let i = index" [attr.data-test]="'token'+i+1" (input)="getInput(inputEl.value, i)" #inputEl 
    inputOtp autocorrect="off" spellcheck="false" autocomplete="off" class="form-control" name="otp" type="text" maxlength="1" />
</form> 